import { render, staticRenderFns } from "./centro_trabajoFormulario.vue?vue&type=template&id=5e962e9f&"
import script from "./centro_trabajoFormulario.vue?vue&type=script&lang=ts&"
export * from "./centro_trabajoFormulario.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports